/**
 * Composable for debounced search on index pages.
 * Handles the ref, debounce, and Inertia navigation.
 */
import { router } from "@inertiajs/vue3"
import { refDebounced } from "@vueuse/core"
import { ref, watch } from "vue"

export function useSearchableIndex(
  initialQuery: string,
  path: () => string,
  baseParams: () => Record<string, string> = () => ({}),
) {
  const search = ref(initialQuery)
  const debouncedSearch = refDebounced(search, 300)

  watch(debouncedSearch, (q) => {
    if (q === initialQuery) return
    router.get(path(), q ? { ...baseParams(), q } : baseParams(), { preserveState: true })
  })

  return { search }
}
